(function () {
  'use strict';
  if (window.PesadoTermsAcceptance) return;

  var ROOT = '[data-pesado-terms]';
  var CHECKBOX = '[data-agree-checkbox]';
  var CHECKOUT = '[name="checkout"], [data-agree-btn], [name="goto_pp"], [name="goto_gc"]';
  var REVOKE_KEY = 'pesado_terms_revoke_v1';
  var model = null;
  var inFlight = false;
  var seen = new WeakSet();
  var checkoutIntent = null;

  function route(path) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.replace(/\/?$/, '/') + path.replace(/^\//, '');
  }

  function journal(version) {
    try {
      if (version) sessionStorage.setItem(REVOKE_KEY, version);
      else sessionStorage.removeItem(REVOKE_KEY);
    } catch (error) {}
  }

  function revoked(version) {
    try { return sessionStorage.getItem(REVOKE_KEY) === version; } catch (error) { return false; }
  }

  function attributes(accepted, version, context) {
    return {
      'Terms accepted at': accepted ? new Date().toISOString() : '',
      'Terms version': accepted ? version : '',
      'Terms accepted via': accepted ? (context === 'drawer' ? 'cart drawer' : 'cart page') : ''
    };
  }

  function serverState(root) {
    var checkbox = root.querySelector(CHECKBOX);
    var data = root.dataset;
    return {
      version: data.termsVersion,
      accepted: Boolean(checkbox && checkbox.checked && data.termsAcceptedAt && data.termsAcceptedVia),
      attributes: {
        'Terms accepted at': data.termsAcceptedAt || '',
        'Terms version': checkbox && checkbox.checked ? data.termsVersion : '',
        'Terms accepted via': data.termsAcceptedVia || ''
      }
    };
  }

  function ready() { return Boolean(model && model.accepted && model.persisted && !model.error); }

  function sync() {
    if (!model) return;
    document.querySelectorAll(ROOT).forEach(function (root) {
      var checkbox = root.querySelector(CHECKBOX);
      var form = root.closest('form');
      if (!checkbox || !form) return;
      checkbox.checked = model.accepted;
      root.classList.toggle('is--accepted', ready());
      root.setAttribute('aria-busy', String(!model.persisted && !model.error));
      if (model.uiMs != null) root.dataset.termsUiMs = String(model.uiMs);
      if (model.saveMs != null) root.dataset.termsSaveMs = String(model.saveMs);
      root.querySelectorAll('[data-terms-attribute]').forEach(function (input) {
        input.value = model.attributes[input.dataset.termsAttribute] || '';
      });
      form.querySelectorAll(CHECKOUT).forEach(function (button) {
        var regular = button.matches('[name="checkout"], [data-agree-btn]');
        var enabled = model.accepted && !model.error && (regular || ready());
        button.classList.toggle('pesado-terms-locked', !enabled);
        button.setAttribute('aria-disabled', String(!enabled));
        button.setAttribute('aria-busy', String(Boolean(checkoutIntent) && !ready()));
      });
      form.querySelectorAll('[data-pesado-checkout-shell]').forEach(function (shell) {
        shell.tabIndex = model.accepted ? -1 : 0;
      });
      form.querySelectorAll('[data-pesado-terms-express]').forEach(function (wrapper) {
        wrapper.classList.toggle('pesado-terms-locked', !ready());
        wrapper.classList.toggle('t4s-pe-none', !ready());
        var content = wrapper.querySelector('[data-pesado-terms-express-buttons]');
        var guard = wrapper.querySelector('[data-pesado-terms-express-guard]');
        if (content) content.inert = !ready();
        if (guard) guard.hidden = ready();
      });
    });
  }

  function showError(root, kind) {
    var error = root.querySelector('.pesado-terms__error');
    if (!error) return;
    if (!error.dataset.requiredText) error.dataset.requiredText = error.textContent;
    var message = kind === 'save' ? root.dataset.termsSaveError : kind === 'saving' ? root.dataset.termsSaving : error.dataset.requiredText;
    if (error.textContent !== message) error.textContent = message;
    error.hidden = false;
    root.classList.add('is--error');
  }

  function clearErrors() {
    document.querySelectorAll(ROOT).forEach(function (root) {
      root.classList.remove('is--error', 'is--attention', 'is--nudging');
      var error = root.querySelector('.pesado-terms__error');
      if (error) error.hidden = true;
    });
  }

  function attention(root) {
    if (!root || !model || model.accepted) return;
    root.classList.add('is--attention');
    if (root.classList.contains('is--nudging')) return;
    root.classList.add('is--nudging');
    setTimeout(function () { root.classList.remove('is--nudging'); }, 320);
  }

  ['pointerover', 'focusin'].forEach(function (type) {
    document.addEventListener(type, function (event) {
      var shell = event.target.closest && event.target.closest('[data-pesado-checkout-shell]');
      if (!shell || (event.relatedTarget && shell.contains(event.relatedTarget))) return;
      var form = shell.closest('form');
      attention(form && form.querySelector(ROOT));
    });
  });
  ['pointerout', 'focusout'].forEach(function (type) {
    document.addEventListener(type, function (event) {
      var shell = event.target.closest && event.target.closest('[data-pesado-checkout-shell]');
      if (!shell || (event.relatedTarget && shell.contains(event.relatedTarget))) return;
      var root = shell.closest('form').querySelector(ROOT);
      if (root && !root.classList.contains('is--error')) root.classList.remove('is--attention');
    });
  });

  function persist() {
    if (!model || inFlight || model.persisted || model.error) return;
    inFlight = true;
    var revision = model.revision;
    var version = model.version;
    var values = Object.assign({}, model.attributes);
    var startedAt = performance.now();
    var controller = new AbortController();
    var timeout = setTimeout(function () { controller.abort(); }, 15000);
    fetch(route('cart/update.js'), {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: values }), signal: controller.signal
    }).then(function (response) {
      if (!response.ok) throw new Error('Terms acceptance could not be saved');
      return response.json();
    }).then(function (cart) {
      Object.keys(values).forEach(function (key) {
        if (String((cart.attributes || {})[key] || '') !== values[key]) throw new Error('Terms acceptance was not confirmed');
      });
      if (revision !== model.revision || version !== model.version) return;
      model.persisted = true;
      model.saveMs = Math.round(performance.now() - startedAt);
      journal('');
      if (model.accepted) clearErrors();
    }).catch(function () {
      if (revision !== model.revision || version !== model.version) return;
      checkoutIntent = null;
      model.error = 'save';
      document.querySelectorAll(ROOT).forEach(function (root) { showError(root, 'save'); });
    }).finally(function () {
      clearTimeout(timeout);
      inFlight = false;
      sync();
      if (revision !== model.revision || version !== model.version) persist();
      resumeCheckout();
    });
  }

  function scan() {
    document.querySelectorAll(ROOT).forEach(function (root) {
      if (seen.has(root)) return;
      seen.add(root);
      var server = serverState(root);
      if (!model || model.version !== server.version) {
        model = { version: server.version, accepted: server.accepted, attributes: server.attributes, persisted: true, revision: 0, touched: false, error: '' };
        if (revoked(server.version)) {
          model.accepted = false;
          model.attributes = attributes(false, server.version, root.dataset.termsContext);
          model.persisted = false;
          model.touched = true;
          model.revision++;
        }
      }
    });
    sync();
    persist();
  }

  function resumeCheckout() {
    if (!checkoutIntent || !ready()) return;
    var intent = checkoutIntent;
    checkoutIntent = null;
    sync();
    var currentRoot = document.querySelector(ROOT + '[data-terms-context="' + intent.context + '"]');
    var form = currentRoot && currentRoot.closest('form');
    var button = form && form.querySelector('[name="checkout"], [data-agree-btn]');
    if (button) button.click();
  }

  function block(event, root, target) {
    if (ready()) {
      if (window.PesadoCartFitWarning) window.PesadoCartFitWarning.guard(event, root.closest('form'), target);
      return;
    }
    event.preventDefault();
    // Do not let Kalles submit a checked form while its acceptance write is pending.
    if (model && model.accepted) {
      event.stopImmediatePropagation();
      if (!model.error && target && target.matches('[name="checkout"], [data-agree-btn]')) {
        checkoutIntent = { context: root.dataset.termsContext };
        showError(root, 'saving');
        sync();
        return;
      }
    }
    showError(root, model && model.error ? 'save' : model && model.accepted ? 'saving' : 'required');
    attention(root);
    root.scrollIntoView({ block: 'center' });
    var checkbox = root.querySelector(CHECKBOX);
    if (checkbox) checkbox.focus({ preventScroll: true });
  }

  document.addEventListener('change', function (event) {
    var checkbox = event.target.closest && event.target.closest(ROOT + ' ' + CHECKBOX);
    if (!checkbox) return;
    var uiStartedAt = performance.now();
    var checked = checkbox.checked;
    checkoutIntent = null;
    scan();
    model.accepted = checked;
    model.attributes = attributes(model.accepted, model.version, checkbox.closest(ROOT).dataset.termsContext);
    model.persisted = false;
    model.touched = true;
    model.error = '';
    model.uiMs = null;
    model.saveMs = null;
    model.revision++;
    if (!model.accepted) journal(model.version);
    clearErrors();
    sync();
    model.uiMs = Math.round((performance.now() - uiStartedAt) * 10) / 10;
    sync();
    persist();
  }, true);

  document.addEventListener('click', function (event) {
    var target = event.target.closest && event.target.closest(CHECKOUT + ', [data-pesado-terms-express-guard], [data-pesado-checkout-shell]');
    var form = target && target.closest('form');
    var root = form && form.querySelector(ROOT);
    if (root) block(event, root, target);
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    var shell = event.target.closest && event.target.closest('[data-pesado-checkout-shell]');
    if (!shell || event.target !== shell) return;
    var root = shell.closest('form').querySelector(ROOT);
    if (root) block(event, root, shell);
  });

  document.addEventListener('submit', function (event) {
    var form = event.target;
    var root = form.querySelector && form.querySelector(ROOT);
    if (!root || (event.submitter && !event.submitter.matches(CHECKOUT))) return;
    block(event, root, event.submitter || form.querySelector(CHECKOUT));
  }, true);

  window.PesadoTermsAcceptance = { refresh: scan, isReady: ready };
  function start() {
    scan();
    new MutationObserver(function (records) {
      if (records.some(function (record) {
        return Array.from(record.addedNodes).some(function (node) {
          return node.nodeType === 1 && (node.matches(ROOT) || node.querySelector(ROOT));
        });
      })) scan();
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
